<mat-sidenav-container fullscreen>
  <mat-sidenav
    #sidenav
    mode="side"
    class="example-sidenav"
    [ngStyle]="{ 'width.em': sidenavWidth }"
    [opened]="_authService.isOpen$ | async">
    <tusangaire-sidebar></tusangaire-sidebar>
  </mat-sidenav>
  <div class="example-sidenav-content">
    <div class="top_header">
      <div class="toggle" (click)="toggleSidenav()">
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div class="top_header_ryt">
        <!-- <span *ngIf="showDot" class="ntf_bell"></span> -->
        <mat-icon
          [ngClass]="showDot ? 'ntf_bell' : ''"
          [matMenuTriggerFor]="menu1"
          (click)="hideDot()">
          notifications_active
        </mat-icon>
        <mat-menu
          #menu1="matMenu"
          xPosition="before"
          yPosition="below"
          class="noti_dropBox">
          <div class="d_flx">
            <h2>{{ 'Notifications' | translate }}</h2>
            <button class="see_link" routerLink="/received-notification">
              {{ 'seeAll' | translate }}
            </button>
          </div>
          <ul class="not_list">
            @for (notification of notificationListing; track notification) {
              <li class="ntf-list" (click)="redirectToPage(notification)">
                <!-- <figure>
                  <img
                    [src]="
                      notificationListing.image
                        ? notificationListing.image
                        : assets.placeHolderLogo
                    "
                    alt="profile" />
                </figure> -->
                <div class="ntf_dt">
                  <h3 class="notification_name">{{ notification?.name }}</h3>
                  <p>{{ notification?.message }}</p>
                  <p class="ntf_tym">{{ notification.createdAt | timeago }}</p>
                </div>
              </li>
            }
          </ul>
        </mat-menu>
        <div class="user-pf">
          <figure mat-button [matMenuTriggerFor]="menu">
            <img
              [src]="
                profile && profile.image ? profile.image : assets.adminIcon
              "
              alt="profile" />
            <figcaption>
              <mat-icon>arrow_drop_down</mat-icon>
            </figcaption>
          </figure>
          <mat-menu
            #menu="matMenu"
            class="dropbox"
            xPosition="before"
            yPosition="below">
            <ul class="hd_menu">
              <li routerLink="/profile">
                <mat-icon>person</mat-icon>
                {{ 'myProfile' | translate }}
              </li>
              <li routerLink="/change-password">
                <mat-icon>lock</mat-icon>
                {{ 'changePassword' | translate }}
              </li>
              <li (click)="logout()">
                <mat-icon>exit_to_app</mat-icon>
                {{ 'Logout' | translate }}
              </li>
            </ul>
          </mat-menu>
        </div>
      </div>
    </div>
    <div class="main_wrapper">
      <router-outlet />
    </div>
    <mat-menu #menu="matMenu"> </mat-menu>
  </div>
</mat-sidenav-container>
